import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon, UsersIcon } from 'lucide-react';
export function CredibilitySection() {
  return <section className="py-24 md:py-32 px-5 md:px-8 bg-carbon border-y border-dark-100" data-id="element-73">
      <div className="max-w-7xl mx-auto" data-id="element-74">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-20 items-center" data-id="element-75">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="lg:col-span-7" data-id="element-76">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-8 tracking-tight leading-[1.05]" data-id="element-77">
              No somos otra agencia. <br data-id="element-78" />
              <span className="text-gold" data-id="element-79">
                Somos tu brazo armado de adquisición.
              </span>
            </h2>
            <p className="text-gray-400 text-lg md:text-xl mb-12 leading-relaxed max-w-2xl" data-id="element-80">
              El 90% de los agentes fracasan en sus primeros 5 años porque
              dependen de su esfera de influencia y de leads compartidos que no
              convierten. Nosotros instalamos un ecosistema predecible que te
              posiciona como la única opción lógica en tu mercado.
            </p>

            <div className="space-y-8" data-id="element-81">
              <div className="border-l-2 border-gold pl-6" data-id="element-82">
                <h4 className="text-white font-bold text-lg md:text-xl mb-2 uppercase tracking-wide" data-id="element-83">
                  Para quién ES esto:
                </h4>
                <p className="text-gray-400 text-base leading-relaxed max-w-xl" data-id="element-84">
                  Agentes a tiempo completo, hambrientos por escalar, que
                  entienden que el marketing es una inversión y están listos
                  para dominar su código postal.
                </p>
              </div>

              <div className="border-l-2 border-red-500 pl-6" data-id="element-85">
                <h4 className="text-white font-bold text-lg md:text-xl mb-2 uppercase tracking-wide" data-id="element-86">
                  Para quién NO es:
                </h4>
                <p className="text-gray-400 text-base leading-relaxed max-w-xl" data-id="element-87">
                  Agentes part-time, personas que buscan "probar a ver qué
                  pasa", o aquellos sin presupuesto operativo para escalar su
                  negocio.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="lg:col-span-5" data-id="element-88">
            <div className="bg-gradient-to-b from-dark-200 to-dark-300 border border-gold/20 border-t-4 border-t-gold p-8 md:p-12 rounded-xl flex flex-col gap-10 shadow-2xl" data-id="element-89">
              <div className="text-center" data-id="element-90">
                <TrendingUpIcon className="w-10 h-10 md:w-12 md:h-12 text-emerald mx-auto mb-4" data-id="element-91" />
                <div className="text-5xl md:text-6xl font-black text-white mb-2" data-id="element-92">
                  300%
                </div>
                <div className="text-gray-400 text-xs md:text-sm font-bold uppercase tracking-widest" data-id="element-93">
                  Aumento Promedio en Citas Calificadas
                </div>
              </div>

              <div className="w-16 h-[1px] bg-dark-100 mx-auto" data-id="element-94" />

              <div className="text-center" data-id="element-95">
                <UsersIcon className="w-10 h-10 md:w-12 md:h-12 text-gold mx-auto mb-4" data-id="element-96" />
                <div className="text-4xl md:text-5xl font-black text-white mb-2" data-id="element-97">
                  Exclusivo
                </div>
                <div className="text-gray-400 text-xs md:text-sm font-bold uppercase tracking-widest" data-id="element-98">
                  Leads 100% Tuyos (No Compartidos)
                </div>
              </div>

              <div className="w-16 h-[1px] bg-dark-100 mx-auto" data-id="element-99" />

              <div className="text-center" data-id="element-100">
                <h3 className="text-2xl md:text-3xl font-black text-gold mb-4 uppercase tracking-tight" data-id="element-101">
                  Nuestra Garantía de Hierro
                </h3>
                <p className="text-gray-300 text-base md:text-lg leading-relaxed" data-id="element-102">
                  Si no instalamos el sistema y generamos oportunidades reales
                  de compra/venta en tus primeros 30 días, trabajamos gratis
                  hasta lograrlo. Cero riesgo para ti. Todo el riesgo está de
                  nuestro lado.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}